













import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
	components: {},
})
export default class RouterLinkButton extends Vue {
	@Prop(Object)
	public route: object;
	@Prop(Boolean)
	public disabled: boolean;
	@Prop(String)
	public buttonText: string;
	@Prop(String)
	public buttonVariant: string;
	@Prop({ default: false })
	public block!: boolean;
	@Prop(String)
	public icon: string;
}
